import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { translate } from '../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { showMiniCart, update } from '../Actions/Cart.action';
import BuyButton from '../Components/BuyButton';
import { pushAddToCart } from '../Services/Analytics.service';

const MiniCart = () => {
    const dispatch = useDispatch();
    const cart = useSelector((state) => state.cart);
    const [updatingRow, setUpdatingRow] = useState(false);
    const hasItems = (cart?.quantity ?? 0) > 0;
    const [orderRows, setOrderRows] = useState(cart?.orderRows);

    useEffect(() => {
        setOrderRows(cart?.orderRows);
    }, [cart]);
    
    const updateOrderRowQuantity = useCallback(
        (articleNumber, quantity, currentQuantity = null) => {
            if (!updatingRow) {
                setUpdatingRow(true);
                dispatch(update(articleNumber, quantity, true)).then(() => {
                    setUpdatingRow(false);
                    try {
                        if (currentQuantity && quantity > currentQuantity) {
                            pushAddToCart(articleNumber, cart);
                        }
                    } catch (error) {}
                }),
                [dispatch]

                setUpdatingRow(false);
            }
        }
    );

    return (
        <Fragment>
            {cart &&
                <Fragment>
                    <a className="minicart-button header-button" role="button" onClick={(e) => { e.preventDefault(); dispatch(showMiniCart(!cart.miniCartIsOpen)); }}>
                        <i className="icon-shopping_cart"></i>
                        {hasItems &&
                            <span><span>{cart.quantity}</span></span>
                        }
                    </a>

                    <div className={`minicart ${cart.miniCartIsOpen ? '' : 'minicart--hidden'}`}>
                        <Fragment>
                            <div className="minicart__header">
                                <div>
                                    <h4>{translate('js.minicart')}</h4>
                                    {hasItems &&
                                        <span>
                                            {cart.quantity} {translate(cart.quantity > 1 ? 'js.minicart.items' : 'js.minicart.item')}
                                        </span>
                                    }
                                </div>
                                <div className="minicart__close-button" role="button" onClick={() => dispatch(showMiniCart(false))}>
                                    <i className="icon-cancel"></i>
                                </div>
                            </div>
                            <div className={`minicart__content ${!hasItems ? 'minicart__content--empty' : ''}`}>
                                {hasItems ? (
                                    <div className="minicart__content__items">
                                        {orderRows.map((orderRow) => (
                                            <div className="cart-row" key={orderRow.rowSystemId}>
                                                <a href={orderRow.url}>
                                                    <img src={orderRow.image} />
                                                </a>
                                                <div>
                                                    <div>
                                                        <span className="cart-row__title">
                                                            <a href={orderRow.url}>{orderRow.name}</a>
                                                        </span>
                                                        <div className="price-info">
                                                            {(orderRow.campaignPrice && orderRow.campaignPrice!==orderRow.price) ? (
                                                                <Fragment>
                                                                    <span className="price">
                                                                        {orderRow.quantity > 1 && (
                                                                            <span className="price__quantity">{orderRow.quantity} x</span>
                                                                        )}
                                                                        {orderRow.campaignPrice}
                                                                    </span>
                                                                    <span className="price price--original-price">{orderRow.price}</span>
                                                                </Fragment>
                                                            ) : (
                                                                <span className="price">
                                                                    {orderRow.quantity > 1 && (
                                                                        <span className="price__quantity">{orderRow.quantity} x</span>
                                                                    )}
                                                                    {orderRow.price}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span className="cart-row__quantity">
                                                            {!orderRow.singleQuantityOnly && (
                                                                <Fragment>
                                                                    <a onClick={() => updateOrderRowQuantity(orderRow.articleNumber, orderRow.quantity - 1, orderRow.quantity)}>
                                                                        <i className="icon-minus_circle"></i>
                                                                    </a>
                                                                    &nbsp;
                                                                    {orderRow.quantityString}
                                                                    &nbsp;
                                                                    <a onClick={() => updateOrderRowQuantity(orderRow.articleNumber, orderRow.quantity + 1, orderRow.quantity)}>
                                                                        <i className="icon-plus_circle"></i>
                                                                    </a>
                                                                    &nbsp;&nbsp;
                                                                </Fragment>
                                                            )}
                                                            <a className="cart-row__quantity__remove" onClick={() => updateOrderRowQuantity(orderRow.articleNumber, 0)}>
                                                                {translate('js.checkout.cart.remove')}
                                                            </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="empty-cart-message">
                                        <i className="icon-shopping_cart"></i>
                                        <span>{translate('js.cart.empty.heading')}</span>
                                        <span>{translate('js.cart.empty.message')}</span>
                                    </div>
                                )}
                            </div>
                            {hasItems &&
                                <Fragment>
                                    {cart.upsellItem &&
                                        <div className="minicart__offer">
                                            <Fragment>
                                                {cart.upsellTitle &&
                                                    <div className="minicart__offer__top">
                                                        <h5>{cart.upsellTitle}</h5>
                                                    </div>
                                                }
                                                <div className="minicart__offer__item">
                                                    {cart.upsellItem.imageUrl &&
                                                        <a href={cart.upsellItem.url} className="minicart__offer__item__image"><img src={cart.upsellItem.imageUrl} /></a>
                                                    }
                                                    <div className="minicart__offer__item__inner">
                                                        <div className="minicart__offer__item__inner__name">
                                                            <a href={cart.upsellItem.url}>{cart.upsellItem.name}</a>
                                                        </div>
                                                        <div className="minicart__offer__item__inner__prices">
                                                            <span className="minicart__offer__item__inner__prices__currency-symbol">
                                                                {cart.upsellItem.currencySymbol}
                                                            </span>
                                                            <span className="minicart__offer__item__inner__prices__original-price">
                                                                {cart.upsellItem.price}
                                                            </span>
                                                            <span className="minicart__offer__item__inner__prices__campaign-price">
                                                                {cart.upsellItem.campaignPrice}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="minicart__offer__item__btn">
                                                        <BuyButton articleNumber={cart.upsellItem.id} isProductCardLayout={true} />
                                                    </div>
                                                </div>
                                            </Fragment>
                                        </div>
                                    }
                                    {cart.freeDeliveryUpsellModel?.freeDeliveryUpsellText &&
                                        <div className="minicart__free-delivery-threshold">
                                            <div className="minicart__free-delivery-threshold__status-bar">
                                                <div className="minicart__free-delivery-threshold__status-bar__text" dangerouslySetInnerHTML={ {__html: cart.freeDeliveryUpsellModel.freeDeliveryUpsellText} } />
                                                <i className="icon-shipping"></i>
                                                <div className="minicart__free-delivery-threshold__status-bar__fill" style={{width: cart.freeDeliveryUpsellModel.progressPercent + '%'}}></div>
                                            </div>
                                        </div>
                                    }
                                </Fragment>
                            }
                            <div className="minicart__footer">
                                {hasItems &&
                                    <div className="minicart__summary">
                                        <div className="minicart__piggy-bank">
                                            {((cart.discountRows && cart.discountRows.length > 0) || cart.orderDiscount) &&
                                                <Fragment>
                                                    <i className="icon-savings"></i>
                                                    <span>{translate('js.minicart.saving')} {cart.discountPositive}</span>
                                                </Fragment>
                                            }
                                        </div>
                                        <div className="minicart__total">
                                            {cart.orderTotal}
                                        </div>
                                    </div>
                                }
                                <div className="minicart__buttons">
                                    {!hasItems ? (
                                        // No items in CartState, link to start page so customer can get shopping!
                                        <a href={cart.emptyCartLinkUrl} className="button button__primary">
                                            {translate('js.cart.empty.button')}<i className="icon-arrow_forward"></i>
                                        </a>
                                    ) : (
                                        <Fragment>
                                            {cart.isSignedIn ? (
                                                <Fragment>
                                                    {/* User is authenticated, link to checkout page */}
                                                    <a href={cart.checkoutUrl} className="button button__primary">
                                                        {translate('js.minicart.checkout')}<i className="icon-arrow_forward"></i>
                                                    </a>
                                                </Fragment>
                                            ) : (
                                                <Fragment>
                                                    {/* User not authenticated, link to sign in and checkout page  */}
                                                    <a href={cart?.loginAndProceedToCheckoutUrl} className="button button__primary">
                                                        {translate('js.minicart.login')}<i className="icon-arrow_forward"></i>
                                                    </a>
                                                    <a href={cart.checkoutUrl} className="button button__outline">
                                                        {translate('js.minicart.checkout.guest')}<i className="icon-arrow_forward"></i>
                                                    </a>
                                                </Fragment>
                                            )}
                                        </Fragment>
                                    )}
                                </div>
                            </div>
                        </Fragment>
                    </div>

                    <div className={`overlay ${cart.miniCartIsOpen ? '' : 'overlay--hidden'}`} onClick={() => dispatch(showMiniCart(false))}></div>
                </Fragment>
            }
        </Fragment>
    );
};

export default MiniCart;
